'use client';

import { useEffect } from 'react';

export default function ClientInit() {
    useEffect(() => {
        import('../../internationalization/i18n');

        // @ts-expect-error: Bootstrap Bundle does not have type definitions
        import('bootstrap/dist/js/bootstrap.bundle.min.js');
    }, []);

    return null;
}